/**
 * Essai gratuit PHC Go (template de page PHC Go Trial et layout du même nom).
 *
 * Version nettoyée du script legacy de phcsoftware.com (`trial/content-trial-submit.php`) :
 * jQuery.ajax devient fetch, et surtout le payload ne transite plus par le
 * navigateur. Le formulaire ACFE l'a déjà construit et stocké côté serveur ; il
 * ne reste ici qu'un jeton à usage unique à échanger contre la création de
 * l'installation.
 *
 * Les trois scénarios du webservice, portés par `status` dans la réponse :
 *
 * - `created` : l'installation est prête, on y redirige ;
 * - `exists`  : une souscription existe déjà, on affiche son lien ;
 * - `error`   : webservice en échec ou jeton périmé, on affiche le message
 *               d'erreur.
 *
 * Les libellés viennent du serveur (templates/components/phc-go-trial-result.twig),
 * traduits par Polylang : plus de switch sur la langue dans le script.
 */
export class PhcGoTrial {

  constructor() {
    this.containers = document.querySelectorAll('[data-js-phc-go-trial]')

    this.containers.forEach(container => this.initContainer(container))

    this.initConsentLinks()
  }

  /**
   * ACF imbrique le texte de la case à cocher dans son <label> : sans ça,
   * ouvrir les CGU ou la politique de confidentialité coche ou décoche le
   * consentement au passage, dans un onglet que l'internaute ne regarde plus.
   */
  initConsentLinks() {
    document.querySelectorAll('.phc-go-trial-gdpr label a').forEach(link => {
      link.addEventListener('click', event => event.stopPropagation())
    })
  }

  /**
   * @param {HTMLElement} container
   */
  initContainer(container) {
    const {trialEndpoint, trialAction, trialToken} = container.dataset

    // Pas de jeton : le message de succès affiche déjà son état final (erreur).
    if (!trialEndpoint || !trialAction || !trialToken) {
      return
    }

    const body = new FormData()
    body.append('action', trialAction)
    body.append('token', trialToken)

    fetch(trialEndpoint, {method: 'POST', credentials: 'same-origin', body})
      .then(response => response.json())
      .then(response => this.handleResponse(container, response))
      .catch(() => this.showState(container, 'error'))
  }

  /**
   * @param {HTMLElement} container
   * @param {Object}      response Réponse wp_send_json_success/error
   */
  handleResponse(container, response) {
    const data = (response && response.data) || {}

    if (!response || !response.success) {
      this.showState(container, 'error')

      return
    }

    if (data.status === 'created' && data.redirect_url) {
      window.location.assign(data.redirect_url)

      return
    }

    if (data.status === 'exists' && data.install_url) {
      const link = container.querySelector('[data-trial-install-url]')

      if (link) {
        link.href = data.install_url
      }

      this.showState(container, 'exists')

      return
    }

    this.showState(container, 'error')
  }

  /**
   * @param {HTMLElement} container
   * @param {String}      state
   */
  showState(container, state) {
    container.querySelectorAll('[data-trial-state]').forEach(element => {
      element.hidden = element.dataset.trialState !== state
    })
  }
}
